import React,{ useCallback, useContext } from 'react';
import logo from '../utils/img/dyb.png';
import './css/styles.css'
import {Form,Input,Button } from 'antd';
import {withRouter,Redirect} from 'react-router'
import app from '../utils/base';
import { AuthContext } from '../context/Auth';

import Title from 'antd/lib/typography/Title';
import {useForm, Controller} from 'react-hook-form';

const LoginPage = ({history}) => {
    const {handleSubmit,control}=useForm();
    // eslint-disable-next-line
  // eslint-disable-next-line
    const onSubmit=useCallback(
        async data=>{

            const {email}=data;
            try {

                await app
                        .auth().sendPasswordResetEmail(email)
                        alert('Se ha enviado un correo a su cuenta para restablecer su contraseña');
                history.push('/');
            }catch (err){
            alert('Correo no valido');
            }

        }
    )     
    

    const {currentUser}= useContext(AuthContext);
    if (currentUser){
        return <Redirect to="/"/>
    }
    return (
    <div className="container">
        <img className="imagen" src={logo} alt="logo"/>
        <Title level={3}  style={{ margin: "15px",color:"#2B7BBC"}} >
            Restablecer contraseña
        </Title>
        <div className="form-login">
        <Form
                layout='vertical'
                size='large'
                style={{height:'100%'}}
                onSubmitCapture={handleSubmit(onSubmit)}
            >
                <Form.Item >
                <Controller placeholder="email" as={Input} type='email' name="email" control={control} />
                </Form.Item>
               
               
                
                <Button type="primary" htmlType='submit'>
                    Restablecer Contraeña
                </Button>
          </Form>
        </div>  
    </div>
    );
}
 
export default withRouter(LoginPage);